<template src="./templates/post-contract.html" />
<script type="text/ecmascript-6">
import { mapActions, mapGetters } from 'vuex'
import AnimationProcessing from 'components/animations/processing'
import Misc from 'src/utils/helper/misc'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import Methods from 'src/pages/contract/script/common.methods'
import FouDropdown from 'components/form/fou-dropdown/'
import TextField from 'src/components/form/text-field'
import { isEmpty } from 'lodash'
import { MdTypography, MdButton, MdCheckbox, MdIconAgreements } from '@antiqua-dls/vue-components'

import { adobeCjaEventEmitter } from '../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES } from '../../../../modules/adobe-cja/constants'

export default {
  name: 'PostContract',

  components: {
    AnimationProcessing,
    TextField,
    FouDropdown,
    MdTypography,
    MdButton,
    MdCheckbox,
    MdIconAgreements,
  },
  data() {
    return {
      country: FouSelectObject(),
      states: FouSelectObject(),
      contractForm: {
        foundryId: '',
        foundryOwnerName: '',
        signerName: '',
        email: '',
        phone: '',
        address1: '',
        address2: '',
        countryCode: '',
        stateCode: '',
        city: '',
        state: '',
        zipCode: '',
        emailConsent: '',
        country: null,
        signerTitle: '',
        status: ''
      },
      yourDetails: {
        name: '',
        title: ''
      },
      showSpinnerText: false,
      showStates: false,
      foundaryName: '',
      errorDSFlag: false,
      errorDSTimeOut: 8000,
      bannedWordOwnerName: false,
      bannedWordCity: false,
      backendCountryValue: '',
      backendStateValue: ''
    }
  },

  methods: {
    ...Methods,
    ...mapActions('contract', ['getAssignedFoundries']),

    updateBannedWords(value) {
      this.bannedWordOwnerName = value
    },

    updateBannedWordCity(value) {
      this.bannedWordCity = value
    },
    setStates(isoCountry) {
      this.states.update(null)
      if (isoCountry !== null && (isoCountry.value === 'AU' || isoCountry.value === 'US' || isoCountry.value === 'CA')) {
        this.showStates = true
        this.states.setOptions({
          obj: this.getStates(isoCountry.value),
          value: 'value',
          name: 'name',
          multiple: true
        })
      } else {
        this.contractForm.state = ''
        this.contractForm.stateCode = ''
        this.showStates = false
      }
    },
    updateCountryValue(location) {
      if (location) {
        this.country.state = 'set'
        this.backendCountryValue = location.value
        this.contractForm.country = location.value
        this.country.update({...location})
      } else {
        this.backendCountryValue = ''
        this.contractForm.country = null
      }
      this.backendStateValue = ''
      this.contractForm.state = ''
      this.contractForm.stateCode = ''
      this.setStates(location)
    },
    updateStateValue(stateLoc) {
      if (stateLoc) {
        this.states.state = 'set'
        this.backendStateValue = stateLoc.value
        if (Array.isArray(stateLoc.value)) {
          this.contractForm.state = stateLoc.value[0]
          this.contractForm.stateCode = stateLoc.value[0]
        } else {
          this.contractForm.state = stateLoc.value
          this.contractForm.stateCode = stateLoc.value
        }
        this.states.update({...stateLoc})
      } else {
        this.backendStateValue = ''
        this.contractForm.state = ''
      }
    },
    acceptAgreement() {
      if (this.bannedWordOwnerName || this.bannedWordCity) {
        return
      }
      this.showSpinnerText = true
      this.contractForm.country = this.backendCountryValue
      this.contractForm.countryCode = this.backendCountryValue
      if (!isEmpty(this.backendStateValue)) {
        this.contractForm.state = this.backendStateValue.split('-').pop()
        this.contractForm.stateCode = this.backendStateValue.split('-').pop()
      }
      this.contractForm.emailConsent = !this.contractForm.emailConsent ? '' : this.contractForm.emailConsent;
      const options = { ...this.contractForm, ...this.yourDetails }
      const userCompleteDetail = JSON.stringify(options)
      localStorage.setItem('userCompleteDetail', userCompleteDetail)
      const analyticsPayload = {
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.MONOTYPE_FONT_DISTRIBUTION_AGREEMENT,
          linkSection: LINK_CATEGORIES.MONOTYPE_FONT_DISTRIBUTION_AGREEMENT,
          linkName: LINK_NAMES.START_SIGN_AGREEMENT,
          linkType: LINK_TYPES.BUTTON
        }
      };
      adobeCjaEventEmitter(analyticsPayload);
      this.$store.dispatch('contract/createNewContract', options)
        .then((res) => {
          this.showSpinnerText = false
          if (res?.success) {
            window.open(
              res.documentUrl,
              '_self'
            )
          } else {
            this.errorDSFlag = true
            setTimeout(() => {
              this.errorDSFlag = false
            }, this.errorDSTimeOut)
          }
        })
    },

    prePopulateAgreementForm() {
      let foundryId = this.getfIdFromRoute()
      let foundaryData = JSON.parse(localStorage.getItem('foundary'))
      if (foundaryData && foundaryData.length > 0) {
        foundaryData.forEach(foundry => {
          if (foundry.foundryId === foundryId) {
            this.contractForm.foundryId = foundry.foundryId
            this.contractForm.foundryOwnerName = foundry.foundryOwnerName
            this.contractForm.email = foundry.email
            this.contractForm.address1 = foundry.addressLine1
            this.contractForm.address2 = foundry.addressLine2
            this.contractForm.zipCode = foundry.addressPostalCode
            this.contractForm.city = foundry.addressCity
            this.contractForm.phone = foundry.phone
            this.contractForm.countryCode = foundry.addressCountryCode
            this.contractForm.emailConsent = foundry.emailConsent
            this.contractForm.state = foundry.addressState
            this.contractForm.stateCode = foundry.addressState
            this.contractForm.status = foundry.status
            if (foundry.signerName === '') {
              let name = localStorage.getItem('display_name')
              let SignName = name.split('@')
              this.contractForm.signerName = SignName[0]
            } else {
              this.contractForm.signerName = foundry.signerName
            }
          }
        })
      }
    },
    populateCountrySelect(contractForm) {
      let val = {label: this.$t('data.countries.' + [contractForm.countryCode]), value: contractForm.countryCode}
      if (this.contractForm.countryCode !== '') {
        this.backendCountryValue = contractForm.countryCode
        this.country.setValues({
          obj: val,
          value: 'value',
          name: 'label'
        })
      }

      if (contractForm.countryCode !== null && (contractForm.countryCode === 'AU' || contractForm.countryCode === 'US' || contractForm.countryCode === 'CA')) {
        const stateVal = contractForm.countryCode + '-' + contractForm.state
        this.backendStateValue = stateVal
        this.states.setValues({
          obj: [{
            value: stateVal,
            label: this.$t(`data.states.${stateVal}`)
          }],
          value: 'value',
          name: 'label'
        })

        if (isEmpty(this.states.options)) {
          this.setStates(val)
        }
      }
    },
    onContractNameBlur(event, field) {
      const name = event.target.value.trim()
      this.contractForm[field] = Misc.toTitleCase(name)
    },
  },

  computed: {
    ...mapGetters('contract', {
      contractData: ['toBeSignedTemplate'],
      spinner: ['toBeSignedSpinner'],
      assignedFoundries: ['list']
    })
  },
  created() {
    this.$store.dispatch('contract/getToBeSignedContractTemplate', this.getfIdFromRoute())
      .then(() => {
        this.setCountries()
        this.contractForm.foundryId = this.contractData.foundry.foundryId
        this.foundaryName = this.contractData.foundry.name
        let foundaryIdForm = this.contractForm.foundryId
        localStorage.setItem('foundaryIdForm', foundaryIdForm)
        let name = this.foundaryName
        localStorage.setItem('FoundaryName', name)
        this.prePopulateAgreementForm()
        this.populateCountrySelect(this.contractForm)
      })
      .catch(() => {
        this.$router.push({ name: '403' })
      })
  }
}
</script>
<style src="./stylesheets/index.scss" lang="scss" module></style>
<style src="./stylesheets/contract.scss" lang="scss" scoped></style>
<style lang="scss">
.sign-agreement-page {
  $field-height: 56px;

  // ── Layout Sections ──────────────────────────────────────────────────
  &__title-bar {
    display: flex;
    align-items: center;
    height: 88px;
    padding: 28px 24px;
    border-bottom: 1px solid var(--md-color--spirits--300);
  }

  &__description {
    padding: 24px;
    border-bottom: 1px solid var(--md-color--spirits--300);
    display: flex;
    flex-direction: column;
    gap: 8px;

    a, .mt-link {
      color: var(--md-color--blue-duck--500);
      text-decoration: underline;
      &:hover { color: var(--md-color--blue-duck--600); }
    }
  }

  &__form { padding: 24px; }

  &__sections {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  &__section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 16px;
    row-gap: 24px;
  }

  // ── Field Wrapper (consistent height for ALL fields) ─────────────────
  &__field {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--md-color--white);
    border: 1px solid var(--md-color--spirits--300);
    border-radius: 8px;
    padding: 16px;
    height: $field-height;
    min-width: 0;
    box-sizing: border-box;
    transition: border-color 0.2s;

    &:focus-within { border-color: var(--md-color--blue-duck--500); }
    &--filled { padding: 8px 16px; }
    &--disabled { opacity: 0.4; cursor: not-allowed; }
    &--error { border-color: var(--md-color--red-babe--500); }

    &--dropdown::after {
      content: '';
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      border: 5px solid transparent;
      border-top-color: var(--md-color--spirits--600);
      pointer-events: none;
    }
  }

  &__field-label {
    font-size: 13px;
    line-height: 16px;
    color: var(--md-color--spirits--600);
  }

  &__field-optional {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    font-size: 13px;
    line-height: 16px;
    color: var(--md-color--spirits--700);
    pointer-events: none;
  }

  // ── Input/Value Styling (shared across TextField + FouDropdown) ──────
  &__field-value,
  &__field .mt-input,
  &__field .dropdown-input {
    width: 100%;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    font-size: 16px;
    line-height: 24px;
    color: var(--md-color--spirits--900);
    font-family: inherit;
    outline: none;
    box-sizing: border-box;

    &::placeholder { color: var(--md-color--spirits--600) !important; }
  }

  &__field .inputFieldClass { margin-bottom: 0 !important; }

  // ── Error Messages (positioned below field) ──────────────────────────
  &__field-error-msg,
  &__field .mt-error-wrapper,
  &__field .mt-error,
  &__field .error-message {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    color: var(--md-color--red-babe--500);
    margin-top: 4px;
    padding: 0;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    z-index: 1;
  }

  // ── FouDropdown Overrides (inside __field) ───────────────────────────
  &__dropdown,
  &__field .dropdown {
    position: static !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 0;
    width: 100%;
    height: auto;
    display: block;

    .dropdownDivClass {
      display: flex;
      align-items: center;
      height: 24px;
      padding: 0 !important;
      border: none !important;
      background: transparent !important;
    }

    .dropdown-input {
      border: none !important;
      background: transparent !important;
      padding: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      border-radius: 0 !important;
      font-size: 16px;
      line-height: 24px;
      color: var(--md-color--spirits--900);

      &::placeholder { visibility: visible !important; color: var(--md-color--spirits--600) !important; }
    }

    .dropdown-input-active {
      padding: 0 !important;
      font-size: 16px;
      line-height: 24px;
      color: var(--md-color--spirits--900);
    }

    .dropdown-btn { display: none !important; }
    .foudropdown_label { display: none !important; }
    .crossBtn { display: none !important; }

    .dropdown-content {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      width: 100%;
      z-index: 100;
    }

    .error-message { display: none !important; }
  }

  &__dropdown--active {
    border: none !important;
    background: transparent !important;
  }

  // ── Email Section ────────────────────────────────────────────────────
  &__email-section {
    padding: 24px;
    border-bottom: 1px solid var(--md-color--spirits--300);
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__email-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  // ── Submit Section ───────────────────────────────────────────────────
  &__submit-section {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  // ── Responsive ───────────────────────────────────────────────────────
  @media (max-width: 1279px) {
    &__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    &__sections { gap: 32px; }
  }

  @media (max-width: 719px) {
    &__grid { grid-template-columns: 1fr; }
    &__title-bar { height: auto; padding: 20px 16px; }
    &__description, &__form, &__email-section, &__submit-section { padding: 16px; }
    &__sections { gap: 24px; }
  }
}
</style>
